// extracted by mini-css-extract-plugin
export default {"formWarpper":"Form_formWarpper__wjLhV","loadingtext":"Form_loadingtext__kWnk9"};